import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
// ✅ IMPORT ICON TAMBAHAN: FaTint (Logo Air)
import { FaUser, FaLock, FaArrowLeft, FaEye, FaEyeSlash, FaTint } from "react-icons/fa"; 
import "../styles/Login.css";

const Login = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); 
    
    // ✅ STATE UNTUK FITUR "INGAT SAYA"
    const [rememberMe, setRememberMe] = useState(false); 
    const navigate = useNavigate();

    // ✅ EFEK: Cek apakah sebelumnya user mencentang "Ingat Saya"
    useEffect(() => {
        const savedUsername = localStorage.getItem("saved_username");
        if (savedUsername) {
            setUsername(savedUsername);
            setRememberMe(true);
        }
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setIsLoading(true);

        if (!username || !password) {
            setError("Username dan password harus diisi!");
            setIsLoading(false);
            return;
        }

        try {
            const res = await axios.post("https://depotaircerdas.com/api/auth/login", {
                username,
                password
            });

            if (res.data.success && res.data.token) {
                // ✅ LOGIKA INGAT SAYA (Frontend Only)
                if (rememberMe) {
                    localStorage.setItem("saved_username", username);
                } else {
                    localStorage.removeItem("saved_username");
                }

                localStorage.setItem("token", res.data.token);
                localStorage.setItem("username", username);
                localStorage.setItem("is_super_admin", res.data.is_super_admin ? 'true' : 'false');
                
                onLoginSuccess();
                setMessage("Login berhasil! Mengalihkan...");

                setTimeout(() => {
                    if (res.data.is_super_admin) {
                        navigate("/admin/register", { replace: true });
                    } else {
                        navigate("/dashboard", { replace: true });
                    }
                }, 1000);
            } else {
                setError(res.data.message || "Login gagal! Periksa kembali username dan password.");
                setIsLoading(false);
            }
        } catch (err) {
            console.error("Login error:", err.response ? err.response.data : err.message);
            setError(err.response?.data?.message || "Terjadi kesalahan saat login.");
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container modern-ui">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>

            <div className="login-box glass-effect">
                <Link to="/" className="btn-back">
                    <FaArrowLeft /> Kembali
                </Link>
                
                {/* ✅ LOGO DAN JUDUL PROFESIONAL */}
                <div className="login-header">
                    <div className="app-logo">
                        <FaTint />
                    </div>
                    <h2 className="login-title">Depot Air Cerdas</h2>
                    <p className="login-subtitle">Selamat datang! Silakan masuk ke akun Anda.</p>
                </div>
                
                {message && <div className="alert success-message fade-in">{message}</div>}
                {error && <div className="alert error-message fade-in">{error}</div>}
                
                <form onSubmit={handleLogin} className="login-form" autoComplete="off">
                    <div className="input-group modern-input">
                        <FaUser className="input-icon" />
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoComplete="off"
                            spellCheck="false"
                        />
                    </div>
                    
                    <div className="input-group modern-input">
                        <FaLock className="input-icon" />
                        <input
                            type={showPassword ? "text" : "password"} 
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            onCut={(e) => e.preventDefault()}
                        />
                        
                        <button 
                            type="button" 
                            className="toggle-password" 
                            onClick={() => setShowPassword(!showPassword)}
                            tabIndex="-1"
                            title={showPassword ? "Sembunyikan Password" : "Tampilkan Password"}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>

                    {/* ✅ OPSI INGAT SAYA & LUPA PASSWORD */}
                    <div className="login-options">
                        <label className="remember-me">
                            <input 
                                type="checkbox" 
                                checked={rememberMe} 
                                onChange={(e) => setRememberMe(e.target.checked)} 
                            />
                            <span>Ingat Saya</span>
                        </label>
                        <Link to="/forgot-password" className="forgot-password-link">Lupa Password?</Link>
                    </div>
                    
                    <button 
                        type="submit" 
                        className={`btn-login ${isLoading ? "loading" : ""}`} 
                        disabled={isLoading}
                    >
                        {isLoading ? <span className="spinner"></span> : "Masuk"}
                    </button>
                </form>
                
                <div className="login-divider">
                    <span>atau</span>
                </div>

                <p className="register-link-text">
                    Belum punya akun? <Link to="/register" className="register-link">Daftar Sekarang</Link>
                </p>
            </div>

            {/* ✅ FOOTER COPYRIGHT */}
            <div className="login-footer">
                <p>&copy; {new Date().getFullYear()} PT Solusi Pemetaan Pasti. All rights reserved.</p>
            </div>
        </div>
    );
};

export default Login;